export default "__VITE_ASSET__DMSbq_bi__"